import { createApp } from 'vue'
import VueApexCharts from "vue3-apexcharts";
import App from './App.vue'
import router from './router'
import store from './store/stateStore'

const app = createApp(App);
app.use(store);
app.use(router);
app.use(VueApexCharts);

const updateTitle = () => {
  const route = router.currentRoute.value;
  const currentPrice = store.state.marketData?.btcUsd || 0;
  const title = route.meta.title || 'Maya.ai';
  document.title = title.replace('{currentPrice}', currentPrice.toFixed(2));
};

store.watch(
  (state) => state.marketData?.btcUsd,
  () => updateTitle()
);

// Watch na rota
router.afterEach(() => updateTitle());

// Atualiza na inicialização
router.isReady().then(() => updateTitle());

app.mount('#app');